





































import { Component,  Vue, Prop } from 'vue-property-decorator';
import { detail, cars } from '@/api/api';
import { Notify } from 'vant';
import loading from '@/components/loading/loading.vue';
import gcoord from 'gcoord';

@Component({
    name: 'mapInfo',
    components: {
        loading
    }
})

export default class MapInfo extends Vue {
    private stations: any[] = [];
    private center: any = '';
    private show: boolean = false;
    private BMap: any = undefined;
    private map: any = undefined;
    private start: any = {};
    private end: any = {};
    private waypoints: any = {};
    private name: string = '';
    private point: any = {lng: 0, lat: 0};
    private infoShow: boolean = false;
    private cars: any[] = [];
    private timer: any = undefined;
    private loading: boolean = true;

    // mounted
    private mounted() {
        this.center = localStorage.getItem('areaName');
        this.show = true;
    }

    // beforeDestroy
    private beforeDestroy() {
        clearInterval(this.timer);
    }

    // methods
    // 地图加载完成
    private ready(e: any): void {
        this.BMap = e.BMap;
        this.map = e.map;
        this.init();
        this.getCars();
        this.timer = setInterval(() => {
            this.getCars();
        }, 3000);
    }
    // 初始化数据
    private init(): void {
        const lineId = this.$route.query.lineId;
        const direction = this.$route.query.direction;
        const areaCode = localStorage.getItem('areaCode');
        detail({lineId, direction, areaCode}).then((res: any) => {
            const busStations: any[] = res.data.busStations;
            const BMap = this.BMap;
            busStations.forEach((item: any) => {
                item.point = new BMap.Point(Number(item.bdlog), Number(item.bdlat));
            });
            this.stations = busStations;
            this.drawLine(busStations);
            this.loading = false;
        });
    }
    // 规划线路
    private drawLine(stations: any): void {
        const map = this.map;
        const BMap = this.BMap;
        const startStation = stations[0].point;
        const endStation = stations[stations.length - 1].point;
        const waypointStation = [];
        for (let i = 1; i < stations.length - 1; i++) {
            waypointStation.push(stations[i].point);
        }
        const driving = new BMap.DrivingRoute(map, {
            renderOptions: { map, autoViewport: true },
            onMarkersSet: (res: any) => {
                map.removeOverlay(res[0].marker); // 删除起点
                map.removeOverlay(res[res.length - 1].marker); // 删除终点]
                for (let i = 1; i < res.length - 1; i++) {
                    if (res[i].Mm) {
                        res[i].Mm.Yc.className = 'hide';
                        res[i].Mm.V.className = 'hide';
                        res[i].Mm.Yc.innerHTML = '';
                    } else if (res[i].Nm) {
                        res[i].Nm.Yc.className = 'hide';
                        res[i].Nm.V.className = 'hide';
                        res[i].Nm.Yc.innerHTML = '';
                    } else if (res[i].Pm) {
                        map.removeOverlay(res[i].Pm);
                    } else if (res[i].Om) {
                        map.removeOverlay(res[i].Om);
                    } else {
                        map.removeOverlay(res[i].Tm);
                    }
                }
            }
        });
        driving.search(startStation, endStation, { waypoints: waypointStation }); // waypoints表示途经点
    }
    // 显示信息
    private showInfo(index: number): void {
        const station: any = this.stations[index];
        this.name = station.siteName;
        this.point  = station.point;
        this.infoShow = true;
    }
    private infoWindowClose(): void {
        this.name = '';
        this.point  = {lng: 0, lat: 0};
    }
    // 获取车辆位置
    private getCars(): void {
        const areaCode = localStorage.getItem('areaCode');
        const direction = this.$route.query.direction;
        const lineCode = this.$route.query.lineCode;
        cars({areaCode, direction, lineCode}).then((res: any) => {
            const cars: any[] = res.data;
            cars.forEach((c: any) => {
                const t: any = gcoord.transform(
                    [c.gpslon, c.gpslat],    // 经纬度坐标
                    gcoord.WGS84,               // 当前坐标系
                    gcoord.BD09                 // 目标坐标系
                );
                c.point = {lng: t[0], lat: t[1]};
            });
            this.cars = cars;
        });
    }
}
